<div class="container" [ngClass]="{ selected: selected }" (click)="newClick()" *ngIf="space.status === 1">
  <div class="header">
    <span class="capacity">
      {{ getSpaceCapacity }}
    </span>
    <div class="image">
      <img [src]="space.image" alt="" />
    </div>
  </div>
  <div class="description">
    <div class="title">{{ space.name }}</div>
    <div class="price" >
      <span *ngIf="priceType == 'price_day'">
        {{ publicPrice }}
        {{ "coworker.coworking-detail.cowings-by-day" | translate }}
      </span>
      <span *ngIf="priceType == 'price_hour'">
        {{ publicPrice }}
        {{ "coworker.coworking-detail.cowings-by-hour" | translate }}
      </span>
      <span *ngIf="priceType == 'price_week'">
        {{ publicPrice }}
        {{ "coworker.coworking-detail.cowings-by-week" | translate }}
      </span>
      <span *ngIf="priceType == 'price_month'">
        {{ publicPrice }}
        {{ "coworker.coworking-detail.cowings-by-month" | translate }}
      </span>
    </div>
  </div>
</div>